import { render, staticRenderFns } from "./SumTable.vue?vue&type=template&id=67ebb7ec&"
import script from "./SumTable.vue?vue&type=script&lang=js&"
export * from "./SumTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports